var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Picture')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }